<template>
  <v-layout 
    fill-height
    justify-center 
    align-center>
    <v-card 
      :width="boxWidth" 
      class="left-transfer-box">
      <v-toolbar 
        dense 
        extended>
        {{ title }}
        <v-spacer/>
        {{ items.length }}
        <template v-slot:extension>
          <v-text-field
            v-model="filter"
            label="Ricerca utente (login/nominativo)"
            color="tree"
            solo
            flat
          />
        </template>
      </v-toolbar>
      <v-card-title>
        <v-list 
          dense           
          class="scrollable_box__wrap">
          <template 
            v-for="item in itemsFiltered" >
            <v-list-tile
              :key="item.item[itemKey]"
              :class="itemSelected && itemSelected[itemKey] === item.item[itemKey] ? 'tree lighten-5' : ''"   
              @click="toggleLeftHandler($event, item.item)"         
            >
              <slot 
                :item="item.item" 
                :selected="itemSelected && itemSelected[itemKey] === item.item[itemKey]"
                name="items">
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.item[itemLabel]"/>
                </v-list-tile-content>
              </slot>
            </v-list-tile>
          </template>
        </v-list>
      </v-card-title>
    </v-card>     
  </v-layout>
</template>

<script>
import Fuse from 'fuse.js/dist/fuse'

export default {
  name: "CBoxSearchr",
  components: {
  },
  props: {
    boxWidth: {type: Number | String, default: 300},
    itemKey: {type: String, default: 'id'},
    itemLabel: {type: String, default: 'nome'},
    title: {type: String, default: () => ('List 1')},
    items: {type: Array, default: () => ([])},
  },
  data (_vm) {
    return {
      itemSelected: null,
      filter: '',
      fuse: new Fuse(this.items, _vm.options),
      options: {
        isCaseSensitive: false,
        findAllMatches: true,
        includeMatches: false,
        includeScore: true,
        useExtendedSearch: false,
        threshold: 0.3,
        location: 0,
        distance: 2,
        maxPatternLength: 32,
        minMatchCharLength: 2,
        keys: [_vm.itemKey, _vm.itemLabel]
      }
    };
  },
  computed: {
    itemsFiltered() {
      return this.fuse.search(this.filter)
    },
  },
  watch: {
    items() {
      this.fuse = new Fuse(this.items, this.options)
      this.itemSelected = null
    },
  },
  methods: {
    toggleLeftHandler(event, item) {
      if (event.target.className.includes('v-list__tile')) {
        this.itemSelected = !this.itemSelected || this.itemSelected[this.itemKey] !== item[this.itemKey] ? item : null
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.scrollable_box__wrap {
  overflow: auto;
  height: calc(~"100vh - 378px");
  width: 100%;
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/Settings/BoxSearch.vue